import Transformer from './Transformer';

class itemTransformerPlanSelector extends Transformer {
    transform(model) {
        const group_id = model.offerid;
        
        return {
            group_id,
            id: model.offerid,
            type: 'planselector',
            waspurchased: model.waspurchased,
            purchasechecked: model.purchasechecked,
            price: model.price,
            offerid: model.offerid,
            currency: model.currency,
            paymentmethod: model.paymentmethod,
            purchasable: model.purchasable,
            purchaseid: model.purchaseid,
            oneoffertype: model.oneoffertype,
            linkworkflowstart: model.linkworkflowstart,
            oneofferdesckey: model.oneofferdesckey,
            gateway: model.gateway,
            oneofferdesc: model.oneofferdesc,
            producttype: model.producttype,
            key: model.key,
            bannerpromo: model.bannerpromo,
            family: model.family,
            banner: model.banner,
            bonus: model.bonus,
            includes: model.includes,
            buy: model.buy,
            style: model.style,
            periodicity: model.periodicity,
            frequency: model.frequency,
        }
    }
}

export default new itemTransformerPlanSelector();



// WEBPACK FOOTER //
// ./src/requests/transformers/itemTransformerPlanSelector.js